import { ConfigProvider, Input, InputRef } from "antd";
import type { InputProps } from "antd";
import { useAntTheme } from "hooks/useAntTheme";
import { forwardRef } from "react";
import styled from "styled-components";
export interface BigInputProps extends InputProps {
  width?: number | string;
  height?: number;
  fontSize?: number;
}
export const BigInput = forwardRef<InputRef, BigInputProps>(
  ({ style, width, height, fontSize, ...props }, ref) => {
    const { theme } = useAntTheme();
    //defaults
    const finalWidth = width ?? 600;
    const finalHeight = height ?? 58;
    const finalFontSize = fontSize ?? 20;

    return (
      <ConfigProvider
        theme={{
          components: {
            Input: {
              activeShadow: theme.boxShadow,
              errorActiveShadow: theme.boxShadow,
              warningActiveShadow: theme.boxShadow,
              colorBorder: "transparent",
            },
          },
        }}
      >
        <StyledInput
          {...props}
          ref={ref}
          data-testid="big-input"
          style={{
            width: finalWidth,
            height: finalHeight,
            fontSize: finalFontSize,
            boxShadow: theme.boxShadow,
            textAlign: "center",
            borderRadius: 10,
            ...style,
          }}
        />
      </ConfigProvider>
    );
  }
);

BigInput.displayName = "BigInput";

const StyledInput = styled(Input)`
  &::placeholder {
    font-weight: 300;
  }
`;
